// its old code dont delete it

// import React, { useEffect, useState } from "react";
// import { Link, useLocation } from "react-router-dom";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// function ShowLedger() {
//   const location = useLocation(); // ✅ Get location to receive updated ledger
//   const [ledgerData, setLedgerData] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [recordsPerPage, setRecordsPerPage] = useState(10);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [deleteId, setDeleteId] = useState(null);
//   const [expandedRows, setExpandedRows] = useState({});

//   useEffect(() => {
//     fetchData();
//   }, []);

//   // ✅ Update ledger locally if coming from UpdateLedger page
//   useEffect(() => {
//     const updatedLedger = location.state?.updatedLedger;
//     if (updatedLedger) {
//       setLedgerData((prev) =>
//         prev.map((item) =>
//           item.HEAD_CODE === updatedLedger.HEAD_CODE ? updatedLedger : item
//         )
//       );
//       setFilteredData((prev) =>
//         prev.map((item) =>
//           item.HEAD_CODE === updatedLedger.HEAD_CODE ? updatedLedger : item
//         )
//       );
//       toast.success("✅ Ledger updated successfully!");
//       // ✅ Clear location.state after update to avoid duplicate updates
//       window.history.replaceState({}, document.title);
//     }
//   }, [location.state]);

//   const fetchData = async () => {
//     setError(null);
//     setLoading(true);
//     try {
//       const response = await fetch("http://localhost:5000/api/ledger", {
//         method: "GET",
//         headers: { "Content-Type": "application/json" },
//       });

//       if (!response.ok) throw new Error("Failed to fetch ledger data");

//       const data = await response.json();
//       setLedgerData(data.data || []);
//       setFilteredData(data.data || []);
//     } catch (err) {
//       console.error("Fetch error:", err);
//       setError("Failed to fetch data. Please try again later.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const confirmDelete = (headCode) => {
//     setDeleteId(headCode);
//   };

//   const handleDelete = async () => {
//     if (!deleteId) return;

//     try {
//       const response = await fetch(
//         `http://localhost:5000/api/ledger/${deleteId}`,
//         {
//           method: "DELETE",
//           headers: { "Content-Type": "application/json" },
//         }
//       );

//       if (!response.ok) throw new Error("Delete failed");

//       const result = await response.json();
//       toast.success(result.message || "✅ Ledger deleted successfully!");

//       setLedgerData((prev) =>
//         prev.filter((item) => String(item.HEAD_CODE) !== String(deleteId))
//       );
//       setFilteredData((prev) =>
//         prev.filter((item) => String(item.HEAD_CODE) !== String(deleteId))
//       );

//       setDeleteId(null);
//     } catch (err) {
//       console.error("Delete Error:", err);
//       toast.error("❌ Failed to delete ledger. Please try again.");
//     }
//   };

//   useEffect(() => {
//     if (!searchQuery.trim()) {
//       setFilteredData(ledgerData);
//     } else {
//       const lower = searchQuery.toLowerCase();
//       setFilteredData(
//         ledgerData.filter((item) =>
//           Object.values(item).some(
//             (val) => val && val.toString().toLowerCase().includes(lower)
//           )
//         )
//       );
//     }
//     setCurrentPage(1);
//   }, [searchQuery, ledgerData]);

//   const totalPages = Math.ceil(filteredData.length / recordsPerPage);
//   const indexOfLastRecord = currentPage * recordsPerPage;
//   const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
//   const currentRecords = filteredData.slice(
//     indexOfFirstRecord,
//     indexOfLastRecord
//   );

//   return (
//     <div className="Payment_div">
//       <div className="payment_maintext">
//         <h6>Ledger</h6>
//         <div>
//           <Link className="payment_breadcrumbs" to={"/ledger"}>
//             <p>Ledger</p>
//           </Link>
//           <span>
//             <i className="fa-solid fa-chevron-right"></i> Master
//           </span>
//         </div>
//       </div>

//       <div className="button_search-payment">
//         <Link to={"/AddLedger"}>
//           <button type="button" className="btn btn-success">
//             <i className="fa-solid fa-plus"></i> Add Ledger
//           </button>
//         </Link>
//         <div className="search-input_box">
//           <input
//             type="search"
//             className="form-control"
//             placeholder="Search for ledger..."
//             value={searchQuery}
//             onChange={(e) => setSearchQuery(e.target.value)}
//           />
//         </div>
//       </div>

//       <div className="search-container mt-3">
//         <div className="records-per-page-container">
//           <label htmlFor="recordsPerPage">Records Per Page:</label>
//           <select
//             id="recordsPerPage"
//             value={recordsPerPage}
//             onChange={(e) => setRecordsPerPage(Number(e.target.value))}
//           >
//             <option value={5}>5</option>
//             <option value={10}>10</option>
//             <option value={15}>15</option>
//             <option value={20}>20</option>
//           </select>
//         </div>
//       </div>

//       <div className="vehicle-type-container mb-5">
//         <ToastContainer position="top-right" autoClose={3000} />

//         {loading && <p>Loading Ledgers...</p>}
//         {error && <p>{error}</p>}

//         {!loading && currentRecords.length > 0 && (
//           <div className="response-container">
//             <div className="table-wrapper">
//               <table className="data-table">
//                 <thead>
//                   <tr>
//                     <th>Ledger Name</th>
//                     <th>Group Name</th>
//                     <th>Address 1</th>
//                     <th>Mobile</th> {/* ✅ Updated column name */}
//                     <th>GST No</th> {/* ✅ Updated column name */}
//                     <th>State</th>
//                     <th>Actions</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {currentRecords.map((item, index) => (
//                     <tr key={item.HEAD_CODE + "-" + index}>
//                       <td>{item.LedgerName || ""}</td>
//                       <td>{item.GroupName || ""}</td>

//                       {/* Address 1 */}
//                       <td>
//                         <div className="address-container">
//                           <span>
//                             {expandedRows[`addr1-${index}`]
//                               ? item.ADDRESS1 || ""
//                               : `${(item.ADDRESS1 || "").slice(0, 20)}${
//                                   item.ADDRESS1 && item.ADDRESS1.length > 20
//                                     ? "..."
//                                     : ""
//                                 }`}
//                           </span>
//                           {item.ADDRESS1 && item.ADDRESS1.length > 20 && (
//                             <button
//                               onClick={() =>
//                                 setExpandedRows((prev) => ({
//                                   ...prev,
//                                   [`addr1-${index}`]: !prev[`addr1-${index}`],
//                                 }))
//                               }
//                               className="expand-btn"
//                             >
//                               {expandedRows[`addr1-${index}`] ? "▲" : "▼"}
//                             </button>
//                           )}
//                         </div>
//                       </td>

//                       {/* ✅ Now showing MOBILE instead of ADDRESS2 */}
//                       <td>{item.MOBILE || ""}</td>

//                       {/* ✅ Now showing GSTNO instead of PHONE */}
//                       <td>{item.GSTNO || ""}</td>

//                       {/* State */}
//                       <td>{item.StateName || ""}</td>

//                       {/* Actions */}
//                       <td>
//                         <div className="seletdata_edit-delet-btn">
//                           <Link to="/UpdateLedger" state={{ ledgerData: item }}>
//                             <button className="selet_edit-btn" title="Edit">
//                               <i className="fa-solid fa-pen-to-square"></i>
//                             </button>
//                           </Link>
//                           <button
//                             className="select_delete-btn"
//                             data-bs-toggle="modal"
//                             data-bs-target="#deleteConfirmationModal"
//                             onClick={() => confirmDelete(item.HEAD_CODE)}
//                           >
//                             <i className="fa-solid fa-trash"></i>
//                           </button>
//                         </div>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>

//             {/* Pagination */}
//             <div
//               className="select_pagination mt-4"
//               style={{
//                 textAlign: "center",
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 gap: "10px",
//               }}
//             >
//               <button
//                 onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
//                 disabled={currentPage === 1}
//                 style={{ padding: "6px 12px", fontSize: "14px", cursor: "pointer" }}
//               >
//                 Previous
//               </button>
//               <span style={{ fontSize: "12px" }}>
//                 Page {currentPage} of {totalPages}
//               </span>
//               <button
//                 onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
//                 disabled={currentPage === totalPages}
//                 style={{ padding: "6px 12px", fontSize: "12px", cursor: "pointer" }}
//               >
//                 Next
//               </button>
//             </div>
//           </div>
//         )}

//         {!loading && !currentRecords.length && <p>No records found.</p>}

//         {/* Delete Confirmation Modal */}
//         <div className="modal fade" id="deleteConfirmationModal">
//           <div className="modal-dialog modal-dialog-centered">
//             <div className="modal-content">
//               <div className="close_topbutton-taxes">
//                 <button
//                   type="button"
//                   className="btn-close"
//                   data-bs-dismiss="modal"
//                 ></button>
//               </div>
//               <div className="delet_icon-boxtaxes">
//                 <i className="fa-solid fa-trash"></i>
//               </div>
//               <div className="taxes_pcolom">
//                 <h6>Confirm Delete</h6>
//                 <p>Are you sure you want to delete this ledger?</p>
//               </div>
//               <div className="close_bottombutton-taxes">
//                 <button
//                   type="button"
//                   className="btn btn-secondary"
//                   data-bs-dismiss="modal"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="button"
//                   className="delete_button"
//                   data-bs-dismiss="modal"
//                   onClick={handleDelete}
//                 >
//                   Delete
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default ShowLedger;

// add here global security key and data append

// import React, { useEffect, useState } from "react";
// import { Link, useLocation } from "react-router-dom";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { SECURITY_KEY } from "../../../globals";

// function ShowLedger() {
//   const location = useLocation(); // ✅ Get location to receive updated ledger
//   const [ledgerData, setLedgerData] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [recordsPerPage, setRecordsPerPage] = useState(10);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [deleteId, setDeleteId] = useState(null);
//   const [expandedRows, setExpandedRows] = useState({});
//   const [responseData, setResponseData] = useState([]);

//   const BASE_REST_API_URL = process.env.REACT_APP_BASE_REST_API_URL;
//   const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;

//   useEffect(() => {
//     fetchData();
//   }, []);

//   // ✅ Update ledger locally if coming from UpdateLedger page
//   useEffect(() => {
//     const updatedLedger = location.state?.updatedLedger;
//     if (updatedLedger) {
//       setLedgerData((prev) =>
//         prev.map((item) =>
//           item.HEAD_CODE === updatedLedger.HEAD_CODE ? updatedLedger : item
//         )
//       );
//       setFilteredData((prev) =>
//         prev.map((item) =>
//           item.HEAD_CODE === updatedLedger.HEAD_CODE ? updatedLedger : item
//         )
//       );
//       toast.success("✅ Ledger updated successfully!");
//       // ✅ Clear location.state after update to avoid duplicate updates
//       window.history.replaceState({}, document.title);
//     }
//   }, [location.state]);

//   const fetchData = async () => {
//     setError(null);
//     setLoading(true);
//     setResponseData([]);

//     const data = new URLSearchParams();
//     data.append("SecurityKey", SECURITY_KEY);
//     data.append("TableName", "HEAD_MAST");
//     data.append("WhereCondition", "All");
//     data.append("*", "*");

//     try {
//       // const response = await fetch("http://localhost:5000/api/ledger", {
//       // const response = await fetch("https://etour.responseinfoway.com/api/ledger", {
//       const response = await fetch(`${BASE_API_URL}/ledger`, {
//         method: "GET",
//         headers: { "Content-Type": "application/json" },
//       });

//       if (!response.ok) throw new Error("Failed to fetch ledger data");

//       const data = await response.json();
//       setLedgerData(data.data || []);
//       setFilteredData(data.data || []);
//     } catch (err) {
//       console.error("Fetch error:", err);
//       setError("Failed to fetch data. Please try again later.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const confirmDelete = (headCode) => {
//     setDeleteId(headCode);
//   };

//   const handleDelete = async () => {
//     if (!deleteId) return;

//     const deleteData = new URLSearchParams();
//     deleteData.append("SecurityKey", SECURITY_KEY);
//     deleteData.append("TableName", "HEAD_MAST");
//     deleteData.append("WhereCondition", `ID=${deleteId}`);

//     try {
//       const response = await fetch(
//         // `http://localhost:5000/api/ledger/${deleteId}`,
//         // `https://etour.responseinfoway.com/api/ledger/${deleteId}`,
//         `${BASE_API_URL}/ledger/${deleteId}`,
//         {
//           method: "DELETE",
//           headers: { "Content-Type": "application/json" },
//         }
//       );

//       if (!response.ok) throw new Error("Delete failed");

//       const result = await response.json();
//       toast.success(result.message || "✅ Ledger deleted successfully!");

//       setLedgerData((prev) =>
//         prev.filter((item) => String(item.HEAD_CODE) !== String(deleteId))
//       );
//       setFilteredData((prev) =>
//         prev.filter((item) => String(item.HEAD_CODE) !== String(deleteId))
//       );

//       setDeleteId(null);
//     } catch (err) {
//       console.error("Delete Error:", err);
//       toast.error("❌ Failed to delete ledger. Please try again.");
//     }
//   };

//   useEffect(() => {
//     if (!searchQuery.trim()) {
//       setFilteredData(ledgerData);
//     } else {
//       const lower = searchQuery.toLowerCase();
//       setFilteredData(
//         ledgerData.filter((item) =>
//           Object.values(item).some(
//             (val) => val && val.toString().toLowerCase().includes(lower)
//           )
//         )
//       );
//     }
//     setCurrentPage(1);
//   }, [searchQuery, ledgerData]);

//   const totalPages = Math.ceil(filteredData.length / recordsPerPage);
//   const indexOfLastRecord = currentPage * recordsPerPage;
//   const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
//   const currentRecords = filteredData.slice(
//     indexOfFirstRecord,
//     indexOfLastRecord
//   );

//   return (
//     <div className="Payment_div">
//       <div className="payment_maintext">
//         <h6>Ledger</h6>
//         <div>
//           <Link className="payment_breadcrumbs" to={"/ledger"}>
//             <p>Ledger</p>
//           </Link>
//           <span>
//             <i className="fa-solid fa-chevron-right"></i> Master
//           </span>
//         </div>
//       </div>

//       <div className="button_search-payment">
//         <Link to={"/AddLedger"}>
//           <button type="button" className="btn btn-success">
//             <i className="fa-solid fa-plus"></i> Add Ledger
//           </button>
//         </Link>
//         <div className="search-input_box">
//           <input
//             type="search"
//             className="form-control"
//             placeholder="Search for ledger..."
//             value={searchQuery}
//             onChange={(e) => setSearchQuery(e.target.value)}
//           />
//         </div>
//       </div>

//       <div className="search-container mt-3">
//         <div className="records-per-page-container">
//           <label htmlFor="recordsPerPage">Records Per Page:</label>
//           <select
//             id="recordsPerPage"
//             value={recordsPerPage}
//             onChange={(e) => setRecordsPerPage(Number(e.target.value))}
//           >
//             <option value={5}>5</option>
//             <option value={10}>10</option>
//             <option value={15}>15</option>
//             <option value={20}>20</option>
//           </select>
//         </div>
//       </div>

//       <div className="vehicle-type-container mb-5">
//         <ToastContainer position="top-right" autoClose={3000} />

//         {loading && <p>Loading Ledgers...</p>}
//         {error && <p>{error}</p>}

//         {!loading && currentRecords.length > 0 && (
//           <div className="response-container">
//             <div className="table-wrapper">
//               <table className="data-table">
//                 <thead>
//                   <tr>
//                     <th>Ledger Name</th>
//                     <th>Group Name</th>
//                     <th>Address 1</th>
//                     <th>Mobile</th> {/* ✅ Updated column name */}
//                     <th>GST No</th> {/* ✅ Updated column name */}
//                     <th>State</th>
//                     <th>Actions</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {currentRecords.map((item, index) => (
//                     <tr key={item.HEAD_CODE + "-" + index}>
//                       <td>{item.LedgerName || ""}</td>
//                       <td>{item.GroupName || ""}</td>

//                       {/* Address 1 */}
//                       <td>
//                         <div className="address-container">
//                           <span>
//                             {expandedRows[`addr1-${index}`]
//                               ? item.ADDRESS1 || ""
//                               : `${(item.ADDRESS1 || "").slice(0, 20)}${
//                                   item.ADDRESS1 && item.ADDRESS1.length > 20
//                                     ? "..."
//                                     : ""
//                                 }`}
//                           </span>
//                           {item.ADDRESS1 && item.ADDRESS1.length > 20 && (
//                             <button
//                               onClick={() =>
//                                 setExpandedRows((prev) => ({
//                                   ...prev,
//                                   [`addr1-${index}`]: !prev[`addr1-${index}`],
//                                 }))
//                               }
//                               className="expand-btn"
//                             >
//                               {expandedRows[`addr1-${index}`] ? "▲" : "▼"}
//                             </button>
//                           )}
//                         </div>
//                       </td>

//                       {/* ✅ Now showing MOBILE instead of ADDRESS2 */}
//                       <td>{item.MOBILE || ""}</td>

//                       {/* ✅ Now showing GSTNO instead of PHONE */}
//                       <td>{item.GSTNO || ""}</td>

//                       {/* State */}
//                       <td>{item.StateName || ""}</td>

//                       {/* Actions */}
//                       <td>
//                         <div className="seletdata_edit-delet-btn">
//                           <Link to="/UpdateLedger" state={{ ledgerData: item }}>
//                             <button className="selet_edit-btn" title="Edit">
//                               <i className="fa-solid fa-pen-to-square"></i>
//                             </button>
//                           </Link>
//                           <button
//                             className="select_delete-btn"
//                             data-bs-toggle="modal"
//                             data-bs-target="#deleteConfirmationModal"
//                             onClick={() => confirmDelete(item.HEAD_CODE)}
//                           >
//                             <i className="fa-solid fa-trash"></i>
//                           </button>
//                         </div>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>

//             {/* Pagination */}
//             <div
//               className="select_pagination mt-4"
//               style={{
//                 textAlign: "center",
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 gap: "10px",
//               }}
//             >
//               <button
//                 onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
//                 disabled={currentPage === 1}
//                 style={{
//                   padding: "6px 12px",
//                   fontSize: "14px",
//                   cursor: "pointer",
//                 }}
//               >
//                 Previous
//               </button>
//               <span style={{ fontSize: "12px" }}>
//                 Page {currentPage} of {totalPages}
//               </span>
//               <button
//                 onClick={() =>
//                   setCurrentPage((p) => Math.min(p + 1, totalPages))
//                 }
//                 disabled={currentPage === totalPages}
//                 style={{
//                   padding: "6px 12px",
//                   fontSize: "12px",
//                   cursor: "pointer",
//                 }}
//               >
//                 Next
//               </button>
//             </div>
//           </div>
//         )}

//         {!loading && !currentRecords.length && <p>No records found.</p>}

//         {/* Delete Confirmation Modal */}
//         <div className="modal fade" id="deleteConfirmationModal">
//           <div className="modal-dialog modal-dialog-centered">
//             <div className="modal-content">
//               <div className="close_topbutton-taxes">
//                 <button
//                   type="button"
//                   className="btn-close"
//                   data-bs-dismiss="modal"
//                 ></button>
//               </div>
//               <div className="delet_icon-boxtaxes">
//                 <i className="fa-solid fa-trash"></i>
//               </div>
//               <div className="taxes_pcolom">
//                 <h6>Confirm Delete</h6>
//                 <p>Are you sure you want to delete this ledger?</p>
//               </div>
//               <div className="close_bottombutton-taxes">
//                 <button
//                   type="button"
//                   className="btn btn-secondary"
//                   data-bs-dismiss="modal"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="button"
//                   className="delete_button"
//                   data-bs-dismiss="modal"
//                   onClick={handleDelete}
//                 >
//                   Delete
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default ShowLedger;






// here use the filter and base the company show the data

import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { showToast } from "../../../utils/customToast";
import "./ShowLedger.css";
import { apiWithLog } from "../../../utils/apiWithLog";
import DeleteConfirmModal from "../../../Component/DeleteModal/DeleteConfirmModal";
import { MasterTableSkeleton } from "../../../Component/Skeleton";

const cleanStr = (val) => {
  if (val == null) return "";
  return String(val).replace(/^["'“”`\s]+|["'“”`\s]+$/g, "").trim();
};

function ShowLedger() {
  const [ledgerData, setLedgerData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [deleteLedgerName, setDeleteLedgerName] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);
  const [expandedRows, setExpandedRows] = useState({});

  // 🔥 COMPANY STATE
  const [selectedCompID, setSelectedCompID] = useState(null);
  const lastCompIDRef = useRef(null);

  const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;

  // ---------------------------------------------------------
  // 🔥 LOAD COMPANY (AUTO UPDATE – NO REFRESH)
  // ---------------------------------------------------------
  useEffect(() => {
    const syncCompany = () => {
      const company = JSON.parse(localStorage.getItem("selectedCompany"));
      const compId = company?.id || null;

      if (compId && lastCompIDRef.current !== compId) {
        lastCompIDRef.current = compId;
        setSelectedCompID(compId);
      }
    };

    syncCompany();

    const interval = setInterval(syncCompany, 500);
    return () => clearInterval(interval);
  }, []);

  // ---------------------------------------------------------
  // 🔥 FETCH ALL LEDGERS
  // ---------------------------------------------------------
  useEffect(() => {
    if (!selectedCompID) return;

    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        const res = await fetch(`${BASE_API_URL}/ledger/${selectedCompID}`);
        if (!res.ok) throw new Error("Failed to fetch ledger data");

        const json = await res.json();
        const cleaned = (json.data || []).map((l) => ({
          ...l,
          LedgerName: cleanStr(l.LedgerName),
          ADDRESS1: cleanStr(l.ADDRESS1),
          ADDRESS2: cleanStr(l.ADDRESS2),
          GroupName: cleanStr(l.GroupName),
          MOBILE: cleanStr(l.MOBILE),
          PHONE: cleanStr(l.PHONE),
          GSTNO: cleanStr(l.GSTNO),
          PANNO: cleanStr(l.PANNO),
          StateName: cleanStr(l.StateName),
        }));
        setLedgerData(cleaned);
      } catch (err) {
        console.error(err);
        setError("Failed to fetch ledger data");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [BASE_API_URL, selectedCompID]);

  // ---------------------------------------------------------
  // 🔥 COMPANY + SEARCH FILTER
  // ---------------------------------------------------------
  useEffect(() => {
    if (!selectedCompID) {
      setFilteredData([]);
      return;
    }

    let data = ledgerData.filter(
      (item) => String(item.CompID) === String(selectedCompID)
    );

    if (searchQuery.trim()) {
      const lower = searchQuery.toLowerCase();
      data = data.filter((item) =>
        [
          item.LedgerName,
          item.GroupName,
          item.ADDRESS1,
          item.MOBILE,
          item.GSTNO,
          item.StateName,
        ].some((val) => val && val.toString().toLowerCase().includes(lower))
      );
    }

    setFilteredData(data);
    setCurrentPage(1);
  }, [ledgerData, selectedCompID, searchQuery]);

  // ---------------------------------------------------------
  // DELETE
  // ---------------------------------------------------------
  const confirmDelete = (item) => {
    setDeleteId(item.HEAD_CODE);
    setDeleteLedgerName(item.LedgerName || "this ledger");
  };

  const handleDelete = async () => {
    if (isDeleting) return;
    if (!deleteId) return;

    try {
      setIsDeleting(true);
      const res = await apiWithLog({
        method: "DELETE",
        url: `${BASE_API_URL}/ledger/${deleteId}`,
        module: "LedgerMaster",
        action: "D",
      });

      const result = res.data || {};

      if (res.status >= 200 && res.status < 300) {
        showToast.delete("Ledger deleted successfully!");
        setLedgerData((prev) =>
          prev.filter((l) => l.HEAD_CODE !== deleteId)
        );
      } else {
        showToast.error(result.message || "Delete failed");
      }
    } catch (err) {
      console.error("Ledger Delete Error:", err);
      showToast.error(err?.response?.data?.message || "Delete failed");
    } finally {
      setIsDeleting(false);
      setDeleteId(null);
      setDeleteLedgerName("");
    }
  };

  // ---------------------------------------------------------
  // PAGINATION
  // ---------------------------------------------------------
  const totalPages = Math.ceil(filteredData.length / recordsPerPage) || 1;
  const indexOfLast = currentPage * recordsPerPage;
  const indexOfFirst = indexOfLast - recordsPerPage;
  const currentRecords = filteredData.slice(indexOfFirst, indexOfLast);

  return (
    <div className="ledger_page_container">

      {/* HEADER BAR WITH TITLE & BREADCRUMBS (NO ICONS) */}
      <div className="ledger_header_bar">
        <div className="ledger_header_title_group">
          <h6 className="ledger_header_title">Ledger Master</h6>
          <div className="ledger_breadcrumbs">
            <Link to="/">Dashboard</Link>
            <span>&gt;</span>
            <span>Master</span>
            <span>&gt;</span>
            <span>Ledger</span>
          </div>
        </div>
      </div>

      {/* TOP CONTROLS: ADD BUTTON + SEARCH + RECORDS PER PAGE */}
      <div className="ledger_top_controls">
        <div className="ledger_top_left">
          <Link to="/AddLedger" className="new_ledger_btn">
            + Add Ledger
          </Link>
          <Link to="/import-ledger" className="import_ledger_top_btn" title="Import Ledgers via CSV or TXT file">
            <i className="fa-solid fa-file-import" style={{ marginRight: "6px" }}></i> Import Ledgers
          </Link>
        </div>

        <div className="ledger_top_right">
          {/* SEARCH BOX */}
          <div className="ledger_search_box">
            <input
              type="search"
              className="ledger_search_input"
              placeholder="Search by ledger, group, GST..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>

          {/* RECORDS PER PAGE */}
          <div className="ledger_records_select_group">
            <label htmlFor="recordsPerPage">Show:</label>
            <select
              id="recordsPerPage"
              className="ledger_records_select"
              value={recordsPerPage}
              onChange={(e) => {
                setRecordsPerPage(Number(e.target.value));
                setCurrentPage(1);
              }}
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={15}>15</option>
              <option value={20}>20</option>
              <option value={50}>50</option>
            </select>
          </div>
        </div>
      </div>

      {/* TABLE CARD */}
      <div className="ledger_table_section">
        {loading && (
          <MasterTableSkeleton columns={7} rows={6} hasToolbar={false} />
        )}

        {error && !loading && (
          <div className="ledger_empty_state">
            <h6>Error Loading Data</h6>
            <p>{error}</p>
          </div>
        )}

        {!loading && !error && currentRecords.length > 0 && (
          <>
            <div className="ledger_table_wrapper">
              <table className="ledger_table">
                <thead>
                  <tr>
                    <th>Ledger Name</th>
                    <th>Group Name</th>
                    <th>Address</th>
                    <th>Mobile</th>
                    <th>GST No</th>
                    <th>State</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {currentRecords.map((item, index) => {
                    const rowKey = item.HEAD_CODE || index;
                    const isAddrExpanded = expandedRows[`addr-${rowKey}`];
                    const addressText = cleanStr(item.ADDRESS1);

                    return (
                      <React.Fragment key={rowKey}>
                        <tr>
                        {/* Ledger Name */}
                        <td className="ledger_name_cell">
                          {cleanStr(item.LedgerName) || "-"}
                        </td>

                        {/* Group Name */}
                        <td>
                          {item.GroupName ? (
                            <span className="ledger_group_badge">
                              {item.GroupName}
                            </span>
                          ) : (
                            "-"
                          )}
                        </td>

                        {/* Address */}
                        <td>
                          <div className="ledger_address_box">
                            <span className="ledger_address_text">
                              {isAddrExpanded
                                ? addressText
                                : `${addressText.slice(0, 24)}${
                                    addressText.length > 24 ? "..." : ""
                                  }` || "-"}
                            </span>
                            {addressText.length > 24 && (
                              <button
                                type="button"
                                className="ledger_expand_btn"
                                title={isAddrExpanded ? "Collapse" : "Expand address"}
                                onClick={() =>
                                  setExpandedRows((prev) => ({
                                    ...prev,
                                    [`addr-${rowKey}`]: !prev[`addr-${rowKey}`],
                                  }))
                                }
                              >
                                {isAddrExpanded ? "▲" : "▼"}
                              </button>
                            )}
                          </div>
                        </td>

                        {/* Mobile */}
                        <td>{item.MOBILE || "-"}</td>

                        {/* GST No */}
                        <td>
                          {item.GSTNO ? (
                            <span className="ledger_gst_badge">{item.GSTNO}</span>
                          ) : (
                            "-"
                          )}
                        </td>

                        {/* State */}
                        <td>{item.StateName || "-"}</td>
                        <td className="ledger_actions_cell">
                          <div className="ledger_actions_wrapper">
                            <Link
                              to="/UpdateLedger"
                              state={{ ledgerData: item }}
                            >
                              <button
                                type="button"
                                className="ledger_btn_edit"
                                title="Edit Ledger"
                              >
                                <i className="fa-solid fa-pen-to-square"></i>
                              </button>
                            </Link>
                            <button
                              type="button"
                              className="ledger_btn_delete"
                              title="Delete Ledger"
                              onClick={() => confirmDelete(item)}
                            >
                              <i className="fa-solid fa-trash-can"></i>
                            </button>
                          </div>
                        </td>
                      </tr>

                      {/* EXPANDED DETAILS ACCORDION */}
                      {expandedRows[item.HEAD_CODE] && (
                        <tr className="ledger_details_row">
                          <td colSpan="7">
                            <div className="ledger_details_grid">
                              <div className="ledger_detail_item">
                                <span className="ledger_detail_label">
                                  Address:
                                </span>
                                <span className="ledger_detail_val">
                                  {cleanStr(item.ADDRESS1) || "N/A"}
                                </span>
                              </div>
                              <div className="ledger_detail_item">
                                <span className="ledger_detail_label">
                                  City / PIN:
                                </span>
                                <span className="ledger_detail_val">
                                  {item.City || "N/A"}{" "}
                                  {item.PIN ? `- ${item.PIN}` : ""}
                                </span>
                              </div>
                              <div className="ledger_detail_item">
                                <span className="ledger_detail_label">
                                  Email:
                                </span>
                                <span className="ledger_detail_val">
                                  {item.Email || "N/A"}
                                </span>
                              </div>
                              <div className="ledger_detail_item">
                                <span className="ledger_detail_label">
                                  PAN No:
                                </span>
                                <span className="ledger_detail_val">
                                  {item.PANNO || "N/A"}
                                </span>
                              </div>
                              <div className="ledger_detail_item">
                                <span className="ledger_detail_label">
                                  Bank:
                                </span>
                                <span className="ledger_detail_val">
                                  {item.BankName || "N/A"}
                                </span>
                              </div>
                              <div className="ledger_detail_item">
                                <span className="ledger_detail_label">
                                  A/C No:
                                </span>
                                <span className="ledger_detail_val">
                                  {item.AccountNo || "N/A"}
                                </span>
                              </div>
                              <div className="ledger_detail_item">
                                <span className="ledger_detail_label">
                                  IFSC:
                                </span>
                                <span className="ledger_detail_val">
                                  {item.IFSCCode || "N/A"}
                                </span>
                              </div>
                              <div className="ledger_detail_item">
                                <span className="ledger_detail_label">
                                  Op. Balance:
                                </span>
                                <span className="ledger_detail_val">
                                  {item.OP_BAL !== undefined &&
                                  item.OP_BAL !== null
                                    ? `₹${item.OP_BAL}`
                                    : "0"}
                                </span>
                              </div>
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
                })}
              </tbody>
              </table>
            </div>

            {/* PAGINATION SECTION (NO ICONS) */}
            <div className="ledger_pagination_container">
              <div className="ledger_pagination_info">
                Showing {indexOfFirst + 1} to{" "}
                {Math.min(indexOfLast, filteredData.length)} of{" "}
                {filteredData.length} records
              </div>

              <div className="ledger_pagination_controls">
                <button
                  type="button"
                  className="ledger_page_btn"
                  onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                  disabled={currentPage === 1}
                >
                  Previous
                </button>
                <span className="ledger_page_badge">
                  Page {currentPage} of {totalPages}
                </span>
                <button
                  type="button"
                  className="ledger_page_btn"
                  onClick={() =>
                    setCurrentPage((p) => Math.min(p + 1, totalPages))
                  }
                  disabled={currentPage === totalPages}
                >
                  Next
                </button>
              </div>
            </div>
          </>
        )}

        {!loading && !error && currentRecords.length === 0 && (
          <div className="ledger_empty_state">
            <h6>No Ledgers Found</h6>
            <p>
              {searchQuery
                ? `No ledgers matching "${searchQuery}"`
                : "No ledgers available for the selected company."}
            </p>
          </div>
        )}
      </div>

      {/* Reusable Custom Delete Confirmation Modal */}
      <DeleteConfirmModal
        isOpen={!!deleteId}
        onClose={() => {
          setDeleteId(null);
          setDeleteLedgerName("");
        }}
        onConfirm={handleDelete}
        title="Delete Ledger?"
        message="Are you sure you want to delete this ledger? This will remove all ledger entries and references."
        itemName={deleteLedgerName}
        loading={isDeleting}
      />
    </div>
  );
}

export default ShowLedger;